import React from 'react'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'
import babyIcon from '../assets/images/baby-colored.png'
import babyIconPink from '../assets/images/baby-pink.png'

ChartJS.register(ArcElement, Tooltip)

const ChildrenChart = ({ data }) => {
  const total = data.length
  const hasChildren = data.filter((d) => d.Children?.toLowerCase() === 'yes').length
  const noChildren = total - hasChildren

  const percentageYes = ((hasChildren / total) * 100).toFixed(0)
  const percentageNo = ((noChildren / total) * 100).toFixed(0)

  const chartOptions = {
    cutout: '80%',
    plugins: {
      tooltip: { enabled: false },
    },
  }

  return (
    <div className="bg-white p-4 rounded shadow text-center">
      <h2 className="text-md font-semibold mb-2">CHILDREN IN HOUSEHOLD</h2>

      <div className="flex justify-center gap-8">
        {/* Has Children */}
        <div className="flex flex-col items-center">
          <div className="relative w-24 h-24">
            <Pie
              data={{
                labels: ['Yes', ''],
                datasets: [
                  {
                    data: [hasChildren, noChildren],
                    backgroundColor: ['#4fd1c5', '#e2e8f0'],
                    borderWidth: 0,
                  },
                ],
              }}
              options={chartOptions}
            />
            <img
              src={babyIcon}
              alt="Has Children"
              className="w-10 h-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          </div>
          <p className="text-sm mt-2 font-semibold">Has Children</p>
          <p className="text-lg font-bold">{percentageYes}%</p>
        </div>

        {/* No Children */}
        <div className="flex flex-col items-center">
          <div className="relative w-24 h-24">
            <Pie
              data={{
                labels: ['No', ''],
                datasets: [
                  {
                    data: [noChildren, hasChildren],
                    backgroundColor: ['#f687b3', '#e2e8f0'],
                    borderWidth: 0,
                  },
                ],
              }}
              options={chartOptions}
            />
            <img
              src={babyIconPink}
              alt="No Children"
              className="w-10 h-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          </div>
          <p className="text-sm mt-2 font-semibold">No Children</p>
          <p className="text-lg font-bold">{percentageNo}%</p>
        </div>
      </div>
    </div>
  )
}

export default ChildrenChart
